import Popups from './Popups';
import RejMessages from '../library/RejMessages';
import noUiSlider from './../../../node_modules/nouislider/distribute/nouislider.js';

export default class Forms {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Forms;
		self.attachEvents();
	}

	static initSelectPlugin($selects) {
		const self = new Forms;
		self.attachSelectPlugin($selects);
	}

	static initDatepickerPlugin($fields) {
		const self = new Forms;
		self.attachDatePickerPlugin($fields);
	}

	static initTimepickerPlugin($fields) {
		const self = new Forms;
		self.attachTimePickerPlugin($fields);
	}

	static setResolutionInputs() {
		$('input[name="_resolution"]').val(window.screen.width + 'x' + window.screen.height);
	}

	attachEvents() {
		const self = this;

		self.attachSelectPlugin($('.js-select2'));
		self.attachSliders($('.js-slider'));
		self.attachDatePickerPlugin($('.js-datepicker'));
		self.attachTimePickerPlugin($('.js-timepicker'));
		self.attachRangeSliders($('.js-range-slider'));
		self.attachCurrencyPrefix($('.js-currency-prefix'));
		self.toggleBusinessTypeOtherField($('select.js-business-type').val());
		self.formatNumbers($('.js-number-format'));
		self.formatYears($('.js-year-format'))

		$('.js-adaptive-placeholder').each(function() {
			self.checkAdaptivePlaceholder($(this));
		});

		window.site.checkAdaptivePlaceholder = function($elements) {
			$elements.each(function() {
				self.checkAdaptivePlaceholder($(this));
			});
		};

		window.site.attachCurrencyPrefix = function($elements) {
			self.attachCurrencyPrefix($elements);
		};

		// Moving submit button on get advice form to be before privacy checkbox
		if($('.advice-form').length > 0){
			var $element = $('.advice-form form button').parent(),
				$destinationElementsTotal = $('.advice-form form .form-group.js-adaptive-placeholder').length;

			$('.advice-form form .form-group.js-adaptive-placeholder').each(function(index){
				if(index == ($destinationElementsTotal - 1)){
					$element.insertAfter($(this));
				}
			});

			if($('.hero').length > 0 && $('.hero').hasClass('mod-has-image')){
				$('.hero .hero-img-alt').addClass('mod-move-up');
			}
		}

		$(document).on('submit', '.js-on-submit-open-popup', function(e) {
			e.preventDefault();

			let $this = $(this),
				popupUrl = $this.attr('action'),
				$emailInput = $this.find('input[type="email"]'),
				email = $emailInput.val(),
				popups = new Popups;

			$emailInput.val('');
			popups.openAjaxPopup(popupUrl + '?email=' + email);
		});

		$(document).on('keyup', '.js-number-format', function() {
			self.formatNumbers($(this));
		});

		$(document).on('keyup', '.js-year-format', function() {
			self.formatYears($(this));
		});

		$(document).on('focus', '.js-adaptive-placeholder input, .js-adaptive-placeholder textarea', function() {
            self.enableAdaptivePlaceholder($(this).parents('.form-group'));
        });

        $(document).on('blur', '.js-adaptive-placeholder input, .js-adaptive-placeholder textarea', function() {
            self.checkAdaptivePlaceholder($(this).parents('.form-group'));
        });

        $(document).on('input change', '.js-adaptive-placeholder input, .js-adaptive-placeholder textarea', function() {
            self.checkAdaptivePlaceholder($(this).parents('.form-group'));
        });

		$(document).on('change select2:select select2:unselect select2:clear', '.js-adaptive-placeholder select', function() {
			self.checkAdaptivePlaceholder($(this).parents('.form-group'));
		});

		$(document).on('select2:open', '.js-adaptive-placeholder select', function() {
			self.enableAdaptivePlaceholder($(this).parents('.form-group'));
		});

		$(document).on('select2:close', '.js-adaptive-placeholder select', function() {
			self.checkAdaptivePlaceholder($(this).parents('.form-group'));
		});

		$(document).on('change', 'select.js-business-type', function() {
			self.toggleBusinessTypeOtherField($(this).val());
		});

		$(document).on('select2:opening select2:closing', function(e) {
			// Don't run in IE 11 and down as this breaks select2 and picks wrong value when selecting an option
			if (typeof window.document.documentMode === 'undefined') {
				setTimeout(function() {
					let $searchField = $('.select2-search__field');

					$searchField.each(function() {
						let $select = $(this).parents('.form-group').find('select');
						if ($select.attr('multiple') != 'multiple') {
							$(this).attr('placeholder', 'Enter keywords...');
						}
					});

				}, 50);
			}
		});

		$(document).on('select2:closing', function(e) {
			setTimeout(function() {
				$('.select2-search__field').val('').blur();
			}, 100);
		});

		$(document).on('change', 'input[type="file"]', function() {
			self.updateFileUploaderSelectedFile($(this));
		});

		$(document).on('change', '.form-checkboxlist[data-max-selections] input[type="checkbox"]', function(e) {
			self.handleCheckboxListMaxSelections($(this), e);
		});

		$(document).on('change', '.js-on-change-submit-form', function(e) {
			// submit the first form parent when any input changes, used for filters
			e.preventDefault();
			$(this).parents('form').request();
		});

	}

	attachCurrencyPrefix($fields) {
		$fields.each(function() {
			$(this).closest('.form-group').addClass('mod-has-currency');
		});
	}

	matchCustom(params, data) {
		if (params.term) {
			var replacements = [
				'ecom',
				'Ecom',
				'ECOM',
				'e com',
				'E com',
				'E COM'
			];

			$.each(replacements, function(key, replacement) {
				if (params.term.indexOf(replacement) !== -1) {
					params.term = params.term.replace(replacement, 'e-com');
				}
			});
		}

		return $.fn.select2.defaults.defaults.matcher(params, data);
	}

	attachSelectPlugin($selects) {
		const self = this;

		$selects.each(function() {
			const $select = $(this);
			const options = {
				placeholder: $select.attr('placeholder'),
				matcher: self.matchCustom,
				width: '100%'
			};

			if ($select.data('disable-search')) {
				options.minimumResultsForSearch = -1;
			}

			if ($select.data('maximum-selection-length')) {
				options.maximumSelectionLength = $select.data('maximum-selection-length');
			}

			$select.select2(options);

			const $selection = $select.next('.select2-container').find('.select2-selection');

			self.setSelectAccessibleName($select, $selection);
		});
	}

	setSelectAccessibleName($select, $selection) {
		const selectAriaLabel = $select.attr('aria-label');

		if (selectAriaLabel) {
			$selection.attr('aria-label', selectAriaLabel);
			return;
		}

		const selectId = $select.attr('id');
		const $label = selectId ? $(`label[for="${selectId}"]`) : null;

		if ($label && $label.length) {
			let labelId = $label.attr('id');
			if (!labelId) {
				labelId = `${selectId}-label`;
				$label.attr('id', labelId);
			}
			$selection.attr('aria-labelledby', labelId);
			return;
		}

		const $closestLabel = $select.closest('.form-group').find('label').first();
		if ($closestLabel.length) {
			$selection.attr('aria-label', $closestLabel.text().trim());
			return;
		}

		const placeholder = $select.attr('placeholder');
		if (placeholder) {
			$selection.attr('aria-label', placeholder);
		}
	}

	attachDatePickerPlugin($fields) {
		const self = this;

		$fields.each(function() {
			let maxDate = $(this).data('max-date'),
				minDate = $(this).data('min-date');

			$(this).pickadate({
				min: new Date(minDate),
				max: new Date(maxDate),
				format: 'dd/mm/yy',
				formatSubmit: 'yyyy-mm-dd',
				hiddenName: true,
				container: 'body',
				selectMonths: true,
				selectYears: 100,
				firstDay: 1
			});
		});
	}

	attachTimePickerPlugin($fields) {
		const self = this;

		$fields.each(function() {

			let maxTime = $(this).data('max-time').split(','),
				minTime = $(this).data('min-time').split(',');

			$(this).pickatime({
				format: 'HH:i',
				container: 'body',
				min: minTime,
				max: maxTime,
			});
		});
	}

	attachSliders($sliders) {
		const self = this;

		$sliders.each(function(){
			var $slider = $(this),
				$wrapper = $slider.parents('.slider-wrapper'),
				slider = $slider[0];

			noUiSlider.create(slider, {
				start: [
		            parseInt($slider.attr('data-start-val'))
		        ],
		        step: 1,
		        connect: [true, false],
		        range: {
					'min': [parseInt($slider.attr('data-min-val'))],
		            'max': [parseInt($slider.attr('data-max-val'))],
				}
		    });

		    slider.noUiSlider.on('update', function(data){
		        var min = Math.round(data[0]),
		            max = Math.round(data[1]),
		            minLabel = min;

		        $wrapper.find('.js-slider-input').val(min);

		        if (min == $sliders.data('max-val')) {
		        	minLabel = min + '+';
		        }

		        $wrapper.find('.js-slider-label').html(minLabel);
		    });

		    slider.noUiSlider.on('end', function(data){
		        var min = Math.round(data[0]),
		            max = Math.round(data[1]),
		            minLabel = min;

		        $wrapper.find('.js-slider-input').val(min);

		        if (min == $sliders.data('max-val')) {
		        	minLabel = min + '+';
		        }

		        $wrapper.find('.js-slider-label').html(minLabel);

		        $wrapper.find('input[type="hidden"]').first();

		        $wrapper.find('.js-slider-input').trigger('change');
		    });

		});
	}

	attachRangeSliders($sliders) {
		const self = this;

		$sliders.each(function(){

			let $slider = $(this),
				$wrapper = $slider.parents('.slider-wrapper'),
				slider = $slider[0];

			if ($slider.attr('data-max-val') >= 5000000) {
				var step = 10000,
					range = {
						'min': [parseInt($slider.attr('data-min-val')), 10000],
						'50%': [500000, 50000],
						'75%': [1000000, 500000],
			            'max': parseInt($slider.attr('data-max-val')),
					};
			} else {
				let step = 1,
					range = {
						'min': parseInt($slider.attr('data-min-val')),
			            'max': parseInt($slider.attr('data-max-val')),
					};
			}

			noUiSlider.create(slider, {
				start: [
		            parseInt($slider.attr('data-start-val')),
		            parseInt($slider.attr('data-end-val'))
		        ],
		        step: step,
		        connect: true,
		        range: range
		    });

		    slider.noUiSlider.on('update', function(data){
		        let min = Math.round(data[0]),
		            max = Math.round(data[1]);

		        $wrapper.find('.js-slider-min-input').val(min);
		        $wrapper.find('.js-slider-max-input').val(max);

		        $wrapper.find('.js-slider-min-label').html(min.toLocaleString('en').split('.')[0]);
		        $wrapper.find('.js-slider-max-label').html(max.toLocaleString('en').split('.')[0] + (max == $slider.attr('data-max-val') ? '+' : ''));
		    });

		    slider.noUiSlider.on('end', function(data){
		        let min = Math.round(data[0]),
		            max = Math.round(data[1]);

		        $wrapper.find('.js-slider-min-input').val(min);
		        $wrapper.find('.js-slider-max-input').val(max);

		        $wrapper.find('.js-slider-min-label').html(min.toLocaleString('en').split('.')[0]);
		        $wrapper.find('.js-slider-max-label').html(max.toLocaleString('en').split('.')[0] + (max == $slider.attr('data-max-val') ? '+' : ''));

		        $wrapper.find('input[type="hidden"]').first();

		        $wrapper.find('.js-slider-min-input').trigger('change');
		    });

		});
	}

	enableAdaptivePlaceholder($field) {
		const self = this,
			$label = $field.find('.form-placeholder');

		$label.addClass('is-active');
	}

	checkAdaptivePlaceholder($field) {
		const self = this,
			$label = $field.find('.form-placeholder'),
			$input = $field.find(':input').not('.select2-search__field'),
			value = $input.val();

		let hasValue = false;
		if (Array.isArray(value)) {
			hasValue = value.length > 0;
		} else if (typeof value === 'string') {
			hasValue = value.trim() !== '';
		} else if (value !== null && value !== undefined) {
			hasValue = String(value).trim() !== '';
		}

		let isAutofilled = false;
		if ($input.length > 0) {
			try {
				isAutofilled = $input[0].matches(':-webkit-autofill, :autofill');
			} catch (e) {}
		}

		if (hasValue || isAutofilled) {
			$label.addClass('is-active');
		} else {
			$label.removeClass('is-active');
		}
	}

	toggleBusinessTypeOtherField(value) {
		const self = this,
			$field = $('.js-business-type-other'),
			otherTypes = ['123', '124', '125', '126', '127'];

		if (otherTypes.indexOf(value) !== -1) {
			$field.show();
		} else {
			$field.hide().val('');
		}
	}

	formatNumbers($fields) {
		const self = this;

		$fields.each(function() {
			let num = $(this).val().replaceAll(',', '');
			num = num.replace(/\D/g,'');
			num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

			$(this).val(num);
		});
	}

	formatYears($fields) {
		const self = this;
		$fields.each(function() {
			let num = $(this).val().replace(/\D/g,'');
			$(this).val(num);
		});
	}

	updateFileUploaderSelectedFile($el) {
		const self = this;

		let filesList = [],
			files = $el.get()[0].files,
			$fileUploader = $el.next('.fileuploader');

		if (files.length > 0) {
			$.each(files, function(key, file) {
				filesList.push(file.name);
			});

			$fileUploader.find('.fileuploader-file').html(filesList.join('<br/>'));
		} else {
			$fileUploader.find('.fileuploader-file').html('');
		}
	}

	handleCheckboxListMaxSelections($input, e) {
		const self = this,
			$wrapper = $input.parents('.form-checkboxlist'),
			$selections = $wrapper.find('input[type="checkbox"]:checked');

		if ($selections.length > 5) {
			$input.prop('checked', false);
			RejMessages.error($wrapper.data('error-message'));
		}
	}
}